<script setup>
onMounted(() => {
  // Select all elements with `intersect:` in their class list
  const elements = document.querySelectorAll('[class*="intersect:"]')

  if (elements.length === 0) {
    console.warn('No elements with intersect: found')
    return
  }

  console.log(`Observing ${elements.length} elements`)

  const observer = new IntersectionObserver((entries, obs) => {
    entries.forEach((entry) => {
      const el = entry.target
      const { isIntersecting } = entry

      if (isIntersecting) {
        el.removeAttribute('no-intersect')

        el.style.animation = 'none'
        void el.offsetHeight // Trigger reflow
        el.style.animation = ''

        if (el.classList.contains('intersect-once')) {
          obs.unobserve(el)
        }
      } else {
        el.setAttribute('no-intersect', '')
      }
    })
  })

  // Observe all matching elements
  elements.forEach((el) => observer.observe(el))
})

useHead({
  title: 'SecuVerif - La solution digitale pour les agences de sécurité.',
  ogTitle: 'SecuVerif - La solution digitale pour les agences de sécurité.',
  ogDescription:
    'SecuVerif est une plateforme qui permet aux agences de sécurité de gérer leurs badges numériques et de les scanner pour accéder aux informations.',
  meta: [
    {
      name: 'description',
      content:
        'SecuVerif est une plateforme qui permet aux agences de sécurité de gérer leurs badges numériques et de les scanner pour accéder aux informations.',
    },
    {
      name: 'keywords',
      content:
        'secuverif, plateforme, agence de sécurité, badges numériques, scan, authentification, sécurité, gestion des badges, plateforme de sécurité',
    },
  ],
})
</script>
<template>
  <div class="bg-white">
    <AppHeader />
    <NuxtPage />
    <AppFooter />
  </div>
</template>

<style>
html {
  font-family: Urbanist, sans-serif;
  scroll-behavior: smooth;
}

body {
  margin: 0;
}
</style>
